import type { ReactNode } from 'react'
import { AlertCircle } from 'lucide-react'
import { useHrContext } from '@/hooks/use-api'

/**
 * Gate a page to HR admins (Co-CEOs + the hr@ role mailbox). HR-admin status is
 * decoupled from CRM roles, so we check the HR context (server-derived) rather
 * than user_type. The API enforces the same boundary regardless.
 */
export function RequireHrAdmin({ children }: { children: ReactNode }) {
  const { data, isLoading } = useHrContext()
  if (isLoading) {
    return (
      <main className="container mx-auto p-6">
        <p role="status" aria-live="polite" className="py-12 text-center text-muted-foreground">
          Loading…
        </p>
      </main>
    )
  }
  if (!data?.isHrAdmin) {
    return (
      <main className="container mx-auto p-6">
        <div role="alert" className="py-12 text-center">
          <AlertCircle className="mx-auto mb-2 h-8 w-8 text-destructive" aria-hidden="true" />
          <p className="font-medium">HR administrator access required</p>
          <p className="text-sm text-muted-foreground">
            This area is available to HR administrators only.
          </p>
        </div>
      </main>
    )
  }
  return <>{children}</>
}
